import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing[5],
    gap: theme.spacing[7],
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    backgroundColor: 'transparent',
  },

  wrapperPressed: {
    backgroundColor: colors.backgroundL1Alpha,
    borderColor: colors.backgroundL1Alpha,
  },

  iconWrapper: {
    width: 64,
    height: 64,
    overflow: 'hidden',
    backgroundColor: colors.backgroundL0,
    borderRadius: theme.borderRadius.m,
    alignItems: 'center',
    justifyContent: 'center',
  },

  contentWrapper: {
    flex: 1,
    gap: theme.spacing[2],
  },

  title: {
    color: colors.textPrimary,
  },

  subtitle: {
    color: colors.textSecondary,
  },
}));
